// pages/About.jsx
import React from "react";

export default function About() {
    return (
        <div className="wrapper">
            <h1>About</h1>
            <div style={{textAlign: "center"}}>
                <img src="/gifs/Execution_Clap.gif" alt="Gif from Execution Clap" />
            </div>
            <h2>TOTAL WAR WARHAMMER 3 - FORUM</h2>
            <p><b>Zrobione przy użyciu:</b></p>
            <ul>
                <li>- React - frontend</li>
                <li>- Express - backend</li>
                <li>- Node.js</li>
                <li>- 3 Energy drinks</li>
                <li>- Cloudflare Turnstile - captcha</li>
                <li>- Markdown</li>
                <li>- <span className="material-symbols-outlined">favorite</span></li>
            </ul>
        </div>
    );
}